type IconProps = React.HTMLAttributes<SVGElement>;

export const BeginnerIcon = (props: IconProps) => (
  <svg width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_13808_4257)">
      <path
        d="M5.15489 19.7077L0.364175 15.3487C0.132177 15.1377 0 14.8385 0 14.525V1.11591C0 0.14868 1.14794 -0.358686 1.86321 0.292216L6.65393 4.6513C6.88593 4.8623 7.01811 5.16142 7.01811 5.47499V18.8841C7.01811 19.8509 5.87016 20.3586 5.15489 19.7077Z"
        fill="#FCCF00"
      />
      <path
        d="M14.2379 15.3487L9.44719 19.7078C8.73193 20.3587 7.58398 19.851 7.58398 18.8841V5.47505C7.58398 5.16147 7.71616 4.86235 7.94816 4.65135L12.7389 0.29227C13.4541 -0.358632 14.6021 0.149078 14.6021 1.11597V14.525C14.6021 14.8386 14.4699 15.1377 14.2379 15.3487Z"
        fill="#00A57B"
      />
    </g>
    <defs>
      <clipPath id="clip0_13808_4257">
        <rect width="14.6021" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
